import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

import { NetworkTemplate, NetworkTemplateBody } from './networks.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    GetNetworkTemplates: builder.query<NetworkTemplate[], { filter?: string; search?: string } | void>({
      query: (params = {}) => ({
        method: 'GET',
        url: `networks/templates`,
        params: params || undefined,
      }),
      transformResponse: (response: ApiResponse<NetworkTemplate[]>) => response?.data ?? [],
      providesTags: [RTKQueryTag.NetworkTemplates],
    }),
    GetNetworkTemplate: builder.query<NetworkTemplate | undefined, { templateId?: string }>({
      query: ({ templateId }) => ({
        method: 'GET',
        url: `networks/templates/${templateId ?? ''}`,
      }),
      transformResponse: (response: ApiResponse<NetworkTemplate>) => response?.data,
      providesTags: [RTKQueryTag.NetworkTemplates],
    }),
    createNetworkTemplate: builder.mutation<ApiResponse<void>, NetworkTemplateBody>({
      query: (body) => ({
        method: 'POST',
        url: `networks/templates`,
        body,
      }),
      invalidatesTags: [RTKQueryTag.NetworkTemplates],
    }),
    updateNetworkTemplate: builder.mutation<ApiResponse<void>, { templateId: string; body: NetworkTemplateBody }>({
      query: ({ templateId, body }) => ({
        method: 'PUT',
        url: `networks/templates/${templateId}`,
        body,
      }),
      invalidatesTags: [RTKQueryTag.NetworkTemplates],
    }),
  }),
});

export const {
  useGetNetworkTemplateQuery,
  useGetNetworkTemplatesQuery,
  useCreateNetworkTemplateMutation,
  useUpdateNetworkTemplateMutation,
} = extendedApiSlice;
